import {createSlice} from "@reduxjs/toolkit";

const initialInvoiceState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    invoiceToView: undefined,
    lastError: null
}

export const callTypes = {
    list: "list",
    action: "action"
}

export const invoicesSlice = createSlice({
    name: "invoices",
    initialState: initialInvoiceState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // find Invoices
        invoicesFetched: (state, action) => {
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        
        // get Invoice
        
        invoiceFetched: (state, action) => {
            state.actionsLoading = false;
            state.invoiceToView = action.payload.invoiceToView;
            state.error = null;
        },
        
        // create Invoice
        invoiceCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(action.payload.invoice);
        },
        
        invoiceDeleted: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities = state.entities.filter(el => el.id !== action.payload.id);
        }
    }
})